import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApi } from "@platform/api";

import type { AxiosInstance } from "axios";

export interface ExcelAppendFile {
  fileName: string;
  fileBytes: string;
}

export interface ExcelAppendFileResponse {
  excelAppendFiles: ExcelAppendFile[];
}

const fetchExcelAppendFile = async (
  axiosInstance: AxiosInstance,
  rfpId: string,
): Promise<ExcelAppendFileResponse> => {
  const result = await axiosInstance.get<ExcelAppendFileResponse>(
    `gateway/rfps/${encodeURIComponent(rfpId)}/excel-append-file`,
  );
  return result.data;
};

const useExcelAppendFile = (
  rfpId: string | undefined,
): UseQueryResult<ExcelAppendFileResponse, Error> => {
  const axiosInstance = useApi();
  return useQuery<ExcelAppendFileResponse, Error>({
    queryKey: ["excel-append-file", rfpId],
    queryFn: () => fetchExcelAppendFile(axiosInstance, rfpId!),
    enabled: !!rfpId,
  });
};

export default useExcelAppendFile;
